import BLManager from '$dependencies/BLManager';

const BLM = {
	install(app, options) {
		app.config.globalProperties.$blm = new BLManager();
	},
};

export default BLM;
